import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { StencilProvider, ThemeMode } from "@amzn/stencil-react-components/context";
import { QueryClientProvider } from "./common/providers/query-client-provider";
import { useConfirmationController } from "./common/flow/confirmation-controller";
import App from "./app";
import "./common/styles/main.scss";

const root = createRoot(document.getElementById("root")!);
root.render(
  <React.StrictMode>
    <StencilProvider themeMode={ThemeMode.Light} mode="dense">
      <QueryClientProvider>
        <BrowserRouter
          getUserConfirmation={(message, callback) =>
            useConfirmationController.getState().open(message, callback)
          }
        >
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </StencilProvider>
  </React.StrictMode>
);
